// extracted by mini-css-extract-plugin
export default {"file-preview":"FilePreview_file-preview__IvoX5","svg":"FilePreview_svg__oUvEC","file-view":"FilePreview_file-view__WSVab","backdrop":"FilePreview_backdrop__skzb9"};